import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../../interfaces/user.interfaces';
import { CommonService } from '../common/common.service';
import { CONTROLLER, METHOD } from '../../constants/endpoint.constants';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService extends CommonService {
  public userDetails!: User;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Get logged-in user details
   * */
  getUserDetails() {
    return this.http
      .get<User>(this.joinApiUrl([CONTROLLER.USER, METHOD.USER_DETAILS]))
      .pipe(
        map((userDetails: User) => {
          this.userDetails = userDetails;
          return userDetails;
        })
      );
  }

  getProfilePic(email: { [key: string]: string }): Observable<any> {
    return this.http.post<any>(
      this.joinApiUrl([CONTROLLER.USER, METHOD.PROFILE_PIC]),
      email
    );
  }
}
